import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { STORAGE_KEYS } from 'sh-www/services/local-storage-fallback';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class SigninRoute extends Route {
  /**
   * Register services
   */
  @service router;
  @service('local-storage-fallback') storage;
  @service session;

  /** @inheritDoc */
  beforeModel(transition) {
    if (this.session.isAuthenticated) {
      // If an authenticated user has landed on /signin, route them to their default experience
      this.router.transitionTo(EMBER_ROUTE_NAMES.START);
    }
  }

  /** @inheritDoc */
  setupController(controller) {
    super.setupController(...arguments);

    const profileSlugToView = this.storage.getItem(STORAGE_KEYS.UNAUTHED_PROFILE_SLUG_TO_VIEW) || null;
    controller.set('profileSlugToView', profileSlugToView);

    if (profileSlugToView) {
      this.storage.removeItem(STORAGE_KEYS.UNAUTHED_PROFILE_SLUG_TO_VIEW);
    }
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.authenticate.cancelAll();
    }
  }

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/signin/');
  }
}

export default SigninRoute;
